import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "./views/Home";
import Step10_Shipping from "./views/Step10_Shipping";
import Confirmation from "./views/Step20_Confirmation";

// Fallback page
import PageNotFound from "./views/components/PageNotFound";

import "./css/style.css";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<PageNotFound />} />
                <Route path="/" element={<Navigate to="/de/home" replace />} />
                <Route path="/:language/home" element={<Home />} />
                <Route path="/:language/shipping/:ticketTypeId" element={<Step10_Shipping />} />
                <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
